import FxxlCore from '@fxxl/core';
import FxxlError from '@fxxl/error';

interface VariantSelectorSelectedDetail {
    pid: number | string;
    level1Index?: number | string;
    level2Index?: number | string;
}

type VariantSelectorSelectedEvent = CustomEvent<VariantSelectorSelectedDetail>;

type ProductDetailAvailabilityScenario =
    | 'initial_without_variant_without_selected_branch'
    | 'initial_without_variant_with_selected_branch'
    | 'variant_selected_without_selected_branch'
    | 'variant_selected_with_selected_branch';

type ProductDetailNoAvailabilityInfoType = 'without_selected_branch' | 'with_selected_branch';

type ProductDetailAvailabilityByVariant = FxxlArtikelBranchInventoryVariantAvailabilityByVariant;
type ProductDetailAvailabilityByArticle = FxxlArtikelBranchInventoryVariantAvailabilityByArticle;
type ProductDetailBranchAvailabilityStatus = 'available' | 'inquiry' | 'unavailable';

interface ProductDetailAvailabilityRow {
    variantId: string;
    branchId: number;
    stock: number;
    onlineAvailable: boolean;
    status: ProductDetailBranchAvailabilityStatus;
}

interface ProductDetailVariantSelectorMapEntry {
    pid?: number | string;
    l1i?: number | string;
}

type ProductDetailVariantSelectorMap = Record<string, ProductDetailVariantSelectorMapEntry>;

interface ProductDetailPageBranchAvailabilityInfo {
    mainProductId: string;
    scenario: ProductDetailAvailabilityScenario;
    variantId: string | null;
    selectedBranchId: number | null;
    hasOnlineStock: boolean;
    hasDisplayStock: boolean;
    hasInquiryInSelectedBranch: boolean;
    availableVariantsCount: number;
    availableBranchesCount: number;
    availableStockCount: number;
    matchingVariantIds: string[];
    matchingBranchIds: number[];
    noAvailabilityInfo: {
        show: boolean;
        type: ProductDetailNoAvailabilityInfoType | null;
    };
}

type ProductDetailBranchSubInfoTextKey =
    | 'branchAvailable'
    | 'branchUnavailable'
    | 'myBranchAvailable'
    | 'myBranchVariantAvailable'
    | 'myBranchInquiry'
    | 'myBranchUnavailable';

interface ProductDetailBranchInfoModalData {
    branchId: number;
    city: string;
    addressName: string;
    street: string;
    zip: string;
    openingTimes: string;
    phone: string;
    email: string;
    image: string;
    branchUrl: string;
}

interface FxxlSideModalApi {
    openSideModal?: () => void;
    hideSideModal?: () => void;
    onSideModalOpen?: () => void;
    onSideModalClose?: () => void;
}

interface ProductDetailBranchTimeInfo {
    is_open?: number;
    status?: string;
}

type ProductDetailBranchTimesByBranch = Record<string, ProductDetailBranchTimeInfo>;
type ProductDetailGetBranchTimesFunction = (
    ids: number | string | Array<number | string>,
    callBack: (timesData: ProductDetailBranchTimesByBranch) => void
) => void;

type SideModalElement = HTMLElement & { fxxlSideModal?: FxxlSideModalApi };

export default class FxxlArtikelStockInfos {
    private articleAvailabilityInfoElementClass: string;
    private articleAvailableMyBranchClass: string;
    private articleUnavilableMyBranchClass: string;
    private articleAvailableBranchClass: string;
    private articleUnavilableBranchClass: string;
    private articleAvailabilityInfoShowCLass: string;
    private articleAvailableInfoLoaderClass: string;
    private pdsVariantSelectorClass: string;
    private fxxlHiddenClass: string;
    private pdsBranchAvailabilityContainerClass: string;
    private pdsBranchAvailabilityContainerWithoutSelectedBranchClass: string;
    private pdsBranchAvailabilitySpinnerClass: string;
    private pdsBranchAvailabilityIconClass: string;
    private pdsBranchAvailabilityInfoClass: string;
    private pdsBranchAvailabilitySelectedBranchClass: string;
    private pdsBranchAvailabilityStatusClass: string;
    private pdsBranchAvailabilityTextBranchAvailableClass: string;
    private pdsBranchAvailabilityTextBranchUnavailableClass: string;
    private pdsBranchAvailabilityTextMyBranchAvailableClass: string;
    private pdsBranchAvailabilityTextMyBranchVariantAvailableClass: string;
    private pdsBranchAvailabilityTextMyBranchInquiryClass: string;
    private pdsBranchAvailabilityTextMyBranchUnavailableClass: string;
    private pdsBranchAvailabilityModalId: string;
    private pdsBranchAvailabilitySearchLinkSelector: string;
    private pdsBranchAvailabilityLinkSelector: string;
    private pdsBranchAvailabilityMatrixModalId: string;
    private pdsBranchInfoModalId: string;
    private pdsBranchInfoLinkSelector: string;
    private pdsBranchInfoMatrixLinkSelector: string;
    private pdsBranchAvailabilityTabsClass: string;
    private pdsBranchAvailabilityLinkClass: string;
    private pdsBranchInfoLinkClass: string;
    private pdsBranchInfoMatrixLinkClass: string;
    private branchFilterChangedEventName: string;
    private productDetailBranchFilterListenerInitialized: boolean;
    private branchInfoModalListenersInitialized: boolean;
    private branchInfoModalKeydownListener: ((event: KeyboardEvent) => void) | null;
    private branchInfoModalLastFocusedElement: HTMLElement | null;
    private branchInfoModalStatusRequestId: number;
    private productDetailBranchLinksReady: boolean;
    private productDetailVariantSelectorListenerInitialized: boolean;
    private productDetailVariantSelectionTimerId: number | null;
    private productDetailVariantSelectionPendingVariantId: string | null;
    private productDetailVariantSelectionPendingRequested: boolean;
    private productDetailVariantSelectionPendingPriority: number;
    private pvdLevel1ItemClass: string;
    private pvdLevel2Class: string;
    private pvdLevel2ItemClass: string;
    private pvdLevel2SelectClass: string;
    private pvdActiveClass: string;
    private branchInventoryClass: string;
    private branchInfoModalClass: string;
    private branchInfoModalEmptyClass: string;
    private branchInfoModalSummaryClass: string;
    private branchInfoModalDetailsClass: string;
    private branchInfoModalImageClass: string;
    private branchInfoModalCityClass: string;
    private branchInfoModalNameClass: string;
    private branchInfoModalOpeningRowClass: string;
    private branchInfoModalOpeningClass: string;
    private branchInfoModalStatusClass: string;
    private branchInfoModalAddressRowClass: string;
    private branchInfoModalAddressClass: string;
    private branchInfoModalPhoneRowClass: string;
    private branchInfoModalPhoneLinkClass: string;
    private branchInfoModalEmailRowClass: string;
    private branchInfoModalEmailLinkClass: string;
    private branchInfoModalPageLinkClass: string;
    private branchInfoModalStatusOpenClass: string;
    private branchInfoModalStatusCloseClass: string;
    private sideModalActiveClass: string;
    private sideModalCloseButtonClass: string;
    private articleDetailBranchButtonClass: string;
    private elementArtikelBranchButtonClass: string;

    constructor() {
        this.articleAvailabilityInfoElementClass = 'fxxl-element-artikel__available';
        this.articleAvailabilityInfoShowCLass = 'fxxl-element-artikel__available-info--show';
        this.articleAvailableMyBranchClass = 'fxxl-element-artikel__available-info--with-my-branch';
        this.articleUnavilableMyBranchClass = 'fxxl-element-artikel__available-info--without-my-branch';
        this.articleAvailableBranchClass = 'fxxl-element-artikel__available-info--with-branch';
        this.articleUnavilableBranchClass = 'fxxl-element-artikel__available-info--without-branch';
        this.articleAvailableInfoLoaderClass = 'fxxl-element-artikel__available-info-loader';
        this.pdsVariantSelectorClass = 'pvd-vs';
        this.fxxlHiddenClass = 'fxxl-hidden';
        this.pdsBranchAvailabilityContainerClass = 'fxxl-artikel-availability-box__content--branch';
        this.pdsBranchAvailabilityContainerWithoutSelectedBranchClass =
            'fxxl-artikel-availability-box__content--branch-without-selected';
        this.pdsBranchAvailabilitySpinnerClass = 'fxxl-loading-spinner-with-text';
        this.pdsBranchAvailabilityIconClass = 'fxxl-artikel-availability-box__icon--branch';
        this.pdsBranchAvailabilityInfoClass = 'fxxl-artikel-availability-box__info--branch';
        this.pdsBranchAvailabilitySelectedBranchClass = 'fxxl-artikel-availability-box__selected_branch';
        this.pdsBranchAvailabilityStatusClass = 'fxxl-artikel-availability-box__status--branch';
        this.pdsBranchAvailabilityTextBranchAvailableClass = 'fxxl-artikel-availability-box__status-text--branch-available';
        this.pdsBranchAvailabilityTextBranchUnavailableClass = 'fxxl-artikel-availability-box__status-text--branch-unavailable';
        this.pdsBranchAvailabilityTextMyBranchAvailableClass = 'fxxl-artikel-availability-box__status-text--my-branch-available';
        this.pdsBranchAvailabilityTextMyBranchVariantAvailableClass = 'fxxl-artikel-availability-box__status-text--my-branch-variant-available';
        this.pdsBranchAvailabilityTextMyBranchInquiryClass = 'fxxl-artikel-availability-box__status-text--my-branch-inquiry';
        this.pdsBranchAvailabilityTextMyBranchUnavailableClass = 'fxxl-artikel-availability-box__status-text--my-branch-unavailable';
        this.pdsBranchAvailabilityModalId = 'search-branch-side-modal';
        this.pdsBranchAvailabilityLinkClass = 'fxxl-artikel-availability-box__link';
        this.pdsBranchAvailabilitySearchLinkSelector =
            `.${this.pdsBranchAvailabilityLinkClass} > a[href="#${this.pdsBranchAvailabilityModalId}"]`;
        this.pdsBranchAvailabilityLinkSelector = this.pdsBranchAvailabilitySearchLinkSelector;
        this.pdsBranchAvailabilityMatrixModalId = 'map_all';
        this.pdsBranchInfoModalId = 'branch-info-side-modal';
        this.pdsBranchInfoLinkClass = 'fxxl-artikel-availability-box__branch-info-link';
        this.pdsBranchInfoLinkSelector = `.${this.pdsBranchInfoLinkClass}[href="#${this.pdsBranchInfoModalId}"]`;
        this.pdsBranchInfoMatrixLinkClass = 'js-fxxl-branch-info-modal-matrix-link';
        this.pdsBranchInfoMatrixLinkSelector = `.${this.pdsBranchInfoMatrixLinkClass}`;
        this.pdsBranchAvailabilityTabsClass = 'fxxl-branch-availability-tabs';
        this.branchFilterChangedEventName = 'fxxl-branch-filter-changed';
        this.productDetailBranchFilterListenerInitialized = false;
        this.branchInfoModalListenersInitialized = false;
        this.branchInfoModalKeydownListener = null;
        this.branchInfoModalLastFocusedElement = null;
        this.branchInfoModalStatusRequestId = 0;
        this.productDetailBranchLinksReady = false;
        this.productDetailVariantSelectorListenerInitialized = false;
        this.productDetailVariantSelectionTimerId = null;
        this.productDetailVariantSelectionPendingVariantId = null;
        this.productDetailVariantSelectionPendingRequested = false;
        this.productDetailVariantSelectionPendingPriority = 0;
        this.pvdLevel1ItemClass = 'pvd-vs__l1-item';
        this.pvdLevel2Class = 'pvd-vs__l2';
        this.pvdLevel2ItemClass = 'pvd-vs__l2-item';
        this.pvdLevel2SelectClass = 'pvd-vs__l2-select';
        this.pvdActiveClass = 'pvd-vs__active';
        this.branchInventoryClass = 'fxxl-branch-inventory';
        this.branchInfoModalClass = 'js-fxxl-branch-info-modal';
        this.branchInfoModalEmptyClass = 'js-fxxl-branch-info-modal-empty';
        this.branchInfoModalSummaryClass = 'js-fxxl-branch-info-modal-summary';
        this.branchInfoModalDetailsClass = 'js-fxxl-branch-info-modal-details';
        this.branchInfoModalImageClass = 'js-fxxl-branch-info-modal-image';
        this.branchInfoModalCityClass = 'js-fxxl-branch-info-modal-city';
        this.branchInfoModalNameClass = 'js-fxxl-branch-info-modal-name';
        this.branchInfoModalOpeningRowClass = 'js-fxxl-branch-info-modal-opening-row';
        this.branchInfoModalOpeningClass = 'js-fxxl-branch-info-modal-opening';
        this.branchInfoModalStatusClass = 'js-fxxl-branch-info-modal-status';
        this.branchInfoModalAddressRowClass = 'js-fxxl-branch-info-modal-address-row';
        this.branchInfoModalAddressClass = 'js-fxxl-branch-info-modal-address';
        this.branchInfoModalPhoneRowClass = 'js-fxxl-branch-info-modal-phone-row';
        this.branchInfoModalPhoneLinkClass = 'js-fxxl-branch-info-modal-phone-link';
        this.branchInfoModalEmailRowClass = 'js-fxxl-branch-info-modal-email-row';
        this.branchInfoModalEmailLinkClass = 'js-fxxl-branch-info-modal-email-link';
        this.branchInfoModalPageLinkClass = 'js-fxxl-branch-info-modal-page-link';
        this.branchInfoModalStatusOpenClass = 'fxxl-branch-info-modal__status--open';
        this.branchInfoModalStatusCloseClass = 'fxxl-branch-info-modal__status--close';
        this.sideModalActiveClass = 'fxxl-side-modal--active';
        this.sideModalCloseButtonClass = 'fxxl-side-modal__header-closebutton';
        this.articleDetailBranchButtonClass = 'fxxl-artikel-detail__branch-button';
        this.elementArtikelBranchButtonClass = 'fxxl-element-artikel__branch-button';
        this.initArticleAvailabilityInfo();
    }

    private initArticleAvailabilityInfo(): void {
        this.ensureProductDetailBranchInfoModalListeners();
        this.renderProductDetailBranchInfoModalContent();
        this.setupProductDetailBranchFilterChangedListener();
    }

    private showCategoryPageAvailabilityInfo(element: HTMLElement | null): void {
        if (element) {
            element.classList.add(this.articleAvailabilityInfoShowCLass);
        }
    }

    private setSelectedBranchLabel(infoElement: HTMLElement | null): void {
        const selectedBranchLabel = window?.FxxlPersonalData?.branchfilterdata?.branch_ort;
        if (infoElement && selectedBranchLabel) {
            const templateText = infoElement.dataset.fxxlBranchTemplate || infoElement.innerHTML;
            if (!infoElement.dataset.fxxlBranchTemplate) {
                infoElement.dataset.fxxlBranchTemplate = templateText;
            }

            infoElement.innerHTML = templateText.replace(/###branch###/g, selectedBranchLabel);
        }
    }
    
    private getSelectedBranchId(): number | null {
        const branchId: number = Number(window?.FxxlPersonalData?.branchfilterdata?.branchId);
        if (Number.isFinite(branchId)) {
            return branchId;
        }

        return null;
    }

    private parseAvailableBranchesList(availableBranchesRaw: string | undefined): number[] {
        if (!availableBranchesRaw) {
            return [];
        }

        try {
            const parsedValue = JSON.parse(availableBranchesRaw) as unknown;
            if (Array.isArray(parsedValue)) {
                return parsedValue
                    .map((branchId) => Number(branchId))
                    .filter((branchId) => Number.isFinite(branchId));
            }

            if (parsedValue && typeof parsedValue === 'object') {
                return Object.values(parsedValue as Record<string, unknown>)
                    .map((branchId) => Number(branchId))
                    .filter((branchId) => Number.isFinite(branchId));
            }
        } catch (_error) {
            return [];
        }

        return [];
    }

    private normalizeProductId(variantId: number | string | null | undefined): string | null {
        if (variantId === null || variantId === undefined) {
            return null;
        }

        const normalizedVariantId = String(variantId).trim();
        if (normalizedVariantId.length > 0) {
            return normalizedVariantId;
        }

        return null;
    }

    private normalizeBranchId(branchId: number | string | null | undefined): number | null {
        const normalizedBranchId = Number(branchId);
        if (!Number.isFinite(normalizedBranchId) || normalizedBranchId <= 0) {
            return null;
        }

        return normalizedBranchId;
    }

    private normalizeLevel1Index(level1Index: number | string | null | undefined): number | null {
        const normalizedLevel1Index = Number(level1Index);
        if (!Number.isFinite(normalizedLevel1Index) || normalizedLevel1Index <= 0) {
            return null;
        }

        return normalizedLevel1Index;
    }

    private getProductDetailVariantSelectorElement(): HTMLElement | null {
        return document.querySelector<HTMLElement>(`.${this.pdsVariantSelectorClass}`);
    }

    private getProductDetailSelectedLevel1Index(): number | null {
        const variantSelectorElement = this.getProductDetailVariantSelectorElement();
        if (!variantSelectorElement) {
            return null;
        }

        const level1IndexFromDataset = this.normalizeLevel1Index(variantSelectorElement.dataset.l1);
        if (level1IndexFromDataset !== null) {
            return level1IndexFromDataset;
        }

        const activeLevel1Element = variantSelectorElement.querySelector<HTMLElement>(
            `.${this.pvdLevel1ItemClass}.${this.pvdActiveClass}`
        );
        return this.normalizeLevel1Index(activeLevel1Element?.dataset.l1i);
    }

    private hasProductDetailSelectedLevel2(): boolean {
        const variantSelectorElement = this.getProductDetailVariantSelectorElement();
        if (!variantSelectorElement || variantSelectorElement.dataset.onlyl1 === 'yes') {
            return false;
        }

        const activeLevel2Element = variantSelectorElement.querySelector<HTMLElement>(
            `.${this.pvdLevel2Class}.${this.pvdActiveClass}`
        );
        if (!activeLevel2Element) {
            return false;
        }

        const activeLevel2Item = activeLevel2Element.querySelector<HTMLElement>(
            `.${this.pvdLevel2ItemClass}.${this.pvdActiveClass}`
        );
        if (activeLevel2Item) {
            return true;
        }

        const selectElement = activeLevel2Element.querySelector<HTMLSelectElement>(
            `select.${this.pvdLevel2SelectClass}`
        );
        if (selectElement && selectElement.value && selectElement.value !== '0') {
            return true;
        }

        const level2Index = Number(variantSelectorElement.dataset.l2);
        if (!Number.isFinite(level2Index)) {
            return false;
        }

        return level2Index > 0;
    }

    private getProductDetailVariantSelectorMap(): ProductDetailVariantSelectorMap | null {
        const windowWithVariantSelectorMap = window as Window & {
            et?: {
                data?: {
                    pvdVariantSelectorMap?: ProductDetailVariantSelectorMap;
                };
            };
        };

        const variantSelectorMap = windowWithVariantSelectorMap.et?.data?.pvdVariantSelectorMap;
        if (!variantSelectorMap || typeof variantSelectorMap !== 'object') {
            return null;
        }

        return variantSelectorMap;
    }

    private getProductDetailVariantIdsByLevel1Index(level1Index: number): Set<string> {
        const variantSelectorMap = this.getProductDetailVariantSelectorMap();
        const variantIds = new Set<string>();

        if (!variantSelectorMap) {
            return variantIds;
        }

        Object.entries(variantSelectorMap).forEach(([variantIdKey, variantMeta]) => {
            const variantLevel1Index = this.normalizeLevel1Index(variantMeta?.l1i);
            if (variantLevel1Index !== level1Index) {
                return;
            }

            const normalizedVariantId = this.normalizeProductId(variantMeta?.pid ?? variantIdKey);
            if (normalizedVariantId !== null) {
                variantIds.add(normalizedVariantId);
            }
        });

        return variantIds;
    }

    private getSelectedBranchIdForProductDetail(): number | null {
        const selectedBranchId = this.getSelectedBranchId();
        if (selectedBranchId !== null && selectedBranchId > 0) {
            return selectedBranchId;
        }

        return null;
    }

    private getBranchInfoModalElement(): SideModalElement | null {
        const modalElement = document.getElementById(this.pdsBranchInfoModalId) as SideModalElement | null;
        if (!modalElement) {
            return null;
        }

        return modalElement;
    }

    private getProductDetailBranchAvailabilityContainer(): HTMLElement | null {
        const branchAvailabilityContainers = document.querySelectorAll<HTMLElement>(`.${this.pdsBranchAvailabilityContainerClass}`);
        if (branchAvailabilityContainers.length === 0) {
            return null;
        }

        // `offsetParent === null` bedeutet hier in der Praxis: Element (oder Parent) ist per
        // `display: none` aus dem Layout entfernt. So wählen wir den tatsächlich sichtbaren Container.
        const visibleContainer = Array.from(branchAvailabilityContainers).find(
            (container) => container.offsetParent !== null
        );

        return visibleContainer || branchAvailabilityContainers[0];
    }


    private getProductDetailMainProductIdFromAvailabilityContainer(): string | null {
        const branchAvailabilityContainer = this.getProductDetailBranchAvailabilityContainer();
        const mainProductId = branchAvailabilityContainer?.dataset?.mainProductId;
        if (!mainProductId) {
            return null;
        }

        return this.normalizeProductId(mainProductId);
    }

    private normalizeTextValue(value: string | undefined): string {
        if (typeof value !== 'string') {
            return '';
        }

        return value.trim();
    }

    private parseAvailableLimitValue(value: unknown): number | null {
        if (typeof value === 'number') {
            if (Number.isFinite(value) && value > 0) {
                return value;
            }
            return null;
        }

        if (typeof value !== 'string') {
            return null;
        }

        const trimmedValue = value.trim();
        if (!trimmedValue) {
            return null;
        }

        const rangeParts = trimmedValue
            .split('-')
            .map((part) => part.trim())
            .filter((part) => part.length > 0);
        if (rangeParts.length >= 1) {
            const maxCandidate = Number(rangeParts[rangeParts.length - 1]);
            if (Number.isFinite(maxCandidate) && maxCandidate > 0) {
                return maxCandidate;
            }
        }

        return null;
    }

    private getBranchAvailableProductLimitFromGlobals(): number | null {
        return this.parseAvailableLimitValue(window?.fxxlArtikelBranchInventoryMaxAvailableLimit);
    }

    private normalizeAvailabilityStatus(
        status: string | undefined,
        stock: number
    ): ProductDetailBranchAvailabilityStatus {
        const normalizedStatus = typeof status === 'string' ? status.trim() : '';
        if (
            normalizedStatus === 'available'
            || normalizedStatus === 'inquiry'
            || normalizedStatus === 'unavailable'
        ) {
            return normalizedStatus;
        }

        if (stock > 0) {
            return 'available';
        }

        return 'unavailable';
    }

    private getProductDetailInquiryUrl(
        mainProductId: string,
        variantId: string,
        branchId: number
    ): string {
        const inquiryUrlsByBranch = window?.fxxlArtikelBranchInventoryVariantInquiryUrls?.[mainProductId]?.[variantId];
        if (!inquiryUrlsByBranch || typeof inquiryUrlsByBranch !== 'object') {
            return '';
        }

        const inquiryUrlFromBranch = inquiryUrlsByBranch[String(branchId)];
        if (typeof inquiryUrlFromBranch === 'string') {
            return inquiryUrlFromBranch;
        }

        return '';
    }

    private ensureProductDetailBranchInquiryLinkHandler(inquiryElement: HTMLAnchorElement): void {
        if (inquiryElement.dataset.fxxlInquiryBound === '1') {
            return;
        }

        inquiryElement.addEventListener('click', (event: Event) => {
            const inquiryMode = inquiryElement.dataset.fxxlInquiryMode;
            if (inquiryMode === 'matrix') {
                event.preventDefault();
                const modalWasOpened = this.openProductDetailBranchAvailabilityModal(this.pdsBranchAvailabilityMatrixModalId);
                if (modalWasOpened) {
                    this.selectProductDetailBranchAvailabilityMatrixTab();
                }
            }
        });

        inquiryElement.dataset.fxxlInquiryBound = '1';
    }

    private applyProductDetailBranchInquiryMatrixLink(inquiryElement: HTMLAnchorElement): void {
        inquiryElement.dataset.fxxlInquiryMode = 'matrix';
        inquiryElement.setAttribute('href', `#${this.pdsBranchAvailabilityMatrixModalId}`);
        inquiryElement.classList.remove('ajax', 'gtm__artikel--probefahrt');
        inquiryElement.removeAttribute('rel');
        inquiryElement.removeAttribute('data-template');
        inquiryElement.removeAttribute('data-wait');
        inquiryElement.removeAttribute('data-matrix-status-mode');
        inquiryElement.dataset.lockedByAjaxHandler = 'false';
    }

    private applyProductDetailBranchInquiryFormLink(
        inquiryElement: HTMLAnchorElement,
        inquiryUrl: string
    ): void {
        inquiryElement.dataset.fxxlInquiryMode = 'inquiry';
        inquiryElement.setAttribute('href', inquiryUrl);
        inquiryElement.setAttribute('rel', 'nofollow');
        inquiryElement.setAttribute('data-template', 'artikel/json_artikel_probefahrt');
        inquiryElement.setAttribute('data-wait', 'true');
        inquiryElement.setAttribute('data-matrix-status-mode', '2');
        inquiryElement.classList.add('ajax', 'gtm__artikel--probefahrt');
        inquiryElement.dataset.lockedByAjaxHandler = 'false';

        const windowWithJsonSetup = window as Window & {
            setupJsonHandler?: (element?: Element) => void;
        };

        if (typeof windowWithJsonSetup.setupJsonHandler === 'function') {
            windowWithJsonSetup.setupJsonHandler(inquiryElement.parentElement || document.body);
        }
    }

    private updateProductDetailBranchInquiryLink(
        inquiryElement: HTMLElement,
        availabilityInfo: ProductDetailPageBranchAvailabilityInfo
    ): void {
        if (!(inquiryElement instanceof HTMLAnchorElement)) {
            return;
        }

        this.ensureProductDetailBranchInquiryLinkHandler(inquiryElement);

        const selectedBranchId = availabilityInfo.selectedBranchId;
        if (selectedBranchId === null) {
            this.applyProductDetailBranchInquiryMatrixLink(inquiryElement);
            return;
        }

        if (availabilityInfo.variantId === null) {
            this.applyProductDetailBranchInquiryMatrixLink(inquiryElement);
            return;
        }

        const inquiryUrl = this.getProductDetailInquiryUrl(
            availabilityInfo.mainProductId,
            availabilityInfo.variantId,
            selectedBranchId
        );

        if (inquiryUrl.length === 0) {
            this.applyProductDetailBranchInquiryMatrixLink(inquiryElement);
            return;
        }

        this.applyProductDetailBranchInquiryFormLink(inquiryElement, inquiryUrl);
    }

    private getBranchInfoBySelectedBranchId(
        mainProductId: string | null,
        selectedBranchId: number
    ): FxxlArtikelBranchInventoryBranchInfo | null {
        const branchInfosByArticle = window?.fxxlArtikelBranchInventoryBranchInfos;
        if (!branchInfosByArticle) {
            return null;
        }

        const branchIdAsString = String(selectedBranchId);

        if (mainProductId !== null) {
            const branchInfosByBranch = branchInfosByArticle[mainProductId];
            if (branchInfosByBranch && branchInfosByBranch[branchIdAsString]) {
                return branchInfosByBranch[branchIdAsString];
            }
        }

        const branchInfosByArticleValues = Object.values(branchInfosByArticle);
        for (let index = 0; index < branchInfosByArticleValues.length; index += 1) {
            const branchInfosByBranch = branchInfosByArticleValues[index];
            if (branchInfosByBranch && branchInfosByBranch[branchIdAsString]) {
                return branchInfosByBranch[branchIdAsString];
            }
        }

        return null;
    }

    private getProductDetailBranchInfoModalData(
        mainProductId: string | null,
        selectedBranchId: number | null
    ): ProductDetailBranchInfoModalData | null {
        if (selectedBranchId === null) {
            return null;
        }

        const branchInfo = this.getBranchInfoBySelectedBranchId(mainProductId, selectedBranchId);
        const branchFilterData = window?.FxxlPersonalData?.branchfilterdata;
        const branchFilterBranchId = this.normalizeBranchId(branchFilterData?.branchId);
        const useBranchFilterData = branchFilterBranchId !== null && branchFilterBranchId === selectedBranchId;

        let city = '';
        let addressName = '';
        let street = '';
        let zip = '';
        let openingTimes = '';
        let phone = '';
        let email = '';
        let image = '';
        let branchUrl = '';

        if (useBranchFilterData) {
            city = this.normalizeTextValue(branchFilterData?.ort);
            if (city.length === 0) {
                city = this.normalizeTextValue(branchFilterData?.ort_name);
            }
            if (city.length === 0) {
                city = this.normalizeTextValue(branchFilterData?.branch_ort);
            }

            addressName = this.normalizeTextValue(branchFilterData?.adresse_name);
            if (addressName.length === 0) {
                addressName = this.normalizeTextValue(branchFilterData?.branch_name);
            }
            street = this.normalizeTextValue(branchFilterData?.strasse);
            zip = this.normalizeTextValue(branchFilterData?.plz);
            openingTimes = this.normalizeTextValue(branchFilterData?.header_name);
            phone = this.normalizeTextValue(branchFilterData?.header_phone);
            email = this.normalizeTextValue(branchFilterData?.email);
            image = this.normalizeTextValue(branchFilterData?.teaser_image);
            branchUrl = this.normalizeTextValue(branchFilterData?.branch_link);
        }

        if (branchInfo) {
            if (city.length === 0) {
                const branchInfoCity = this.normalizeTextValue(branchInfo.ort);
                if (branchInfoCity.length > 0) {
                    city = branchInfoCity;
                } else {
                    city = this.normalizeTextValue(branchInfo.ort_name);
                }
            }
            if (addressName.length === 0) {
                addressName = this.normalizeTextValue(branchInfo.adresse_name);
                if (addressName.length === 0) {
                    addressName = this.normalizeTextValue(branchInfo.branch_name);
                }
            }
            if (street.length === 0) {
                street = this.normalizeTextValue(branchInfo.strasse);
            }
            if (zip.length === 0) {
                zip = this.normalizeTextValue(branchInfo.plz);
            }
            if (openingTimes.length === 0) {
                openingTimes = this.normalizeTextValue(branchInfo.header_name);
            }
            if (phone.length === 0) {
                phone = this.normalizeTextValue(branchInfo.header_phone);
            }
            if (email.length === 0) {
                email = this.normalizeTextValue(branchInfo.email);
            }
            if (image.length === 0) {
                image = this.normalizeTextValue(branchInfo.teaser_image);
            }
            if (branchUrl.length === 0) {
                branchUrl = this.normalizeTextValue(branchInfo.branch_url);
            }
        }

        if (useBranchFilterData) {
            if (city.length === 0) {
                city = this.normalizeTextValue(branchFilterData?.branch_ort);
            }

            const branchFilterLink = this.normalizeTextValue(branchFilterData?.branch_link);
            if (branchUrl.length === 0) {
                branchUrl = branchFilterLink;
            }
        }

        if (
            city.length === 0
            && addressName.length === 0
            && street.length === 0
            && zip.length === 0
            && openingTimes.length === 0
            && phone.length === 0
            && email.length === 0
            && image.length === 0
            && branchUrl.length === 0
        ) {
            return null;
        }

        return {
            branchId: selectedBranchId,
            city,
            addressName,
            street,
            zip,
            openingTimes,
            phone,
            email,
            image,
            branchUrl
        };
    }

    private getProductDetailBranchInfoModalAddress(modalData: ProductDetailBranchInfoModalData): string {
        let address = '';

        if (modalData.street.length > 0) {
            address = modalData.street;
        }

        let secondLine = '';
        if (modalData.zip.length > 0) {
            secondLine = modalData.zip;
        }
        if (modalData.city.length > 0) {
            if (secondLine.length > 0) {
                secondLine += ' ';
            }
            secondLine += modalData.city;
        }

        if (secondLine.length > 0) {
            if (address.length > 0) {
                address += '\n';
            }
            address += secondLine;
        }

        if (address.length === 0 && modalData.city.length > 0) {
            address = modalData.city;
        }

        return address;
    }

    private getProductDetailBranchInfoModalOpeningTimes(modalData: ProductDetailBranchInfoModalData): string {
        if (modalData.openingTimes.length === 0) {
            return '';
        }

        // Nur an Kommas trennen, wenn danach ein neuer Wochentag-Block beginnt,
        // damit Zeiten wie "Di.-Fr.: 8 - 13 Uhr, 15 - 18 Uhr, Sa.: 10 - 12 Uhr"
        // pro Tag in einer Zeile bleiben.
        // Todo: Die Öffnungszeiten sollen mal irgendwann aus den strukturierten Daten zusammengebaut werden
        let openingTimes = modalData.openingTimes.replace(/,\s*(?=(Mo|Di|Mi|Do|Fr|Sa|So)\b)/g, '\n');
        openingTimes = openingTimes.replace(/\n{2,}/g, '\n');
        openingTimes = openingTimes.trim();

        return openingTimes;
    }

    private setElementVisibility(element: HTMLElement | null, isVisible: boolean): void {
        if (!element) {
            return;
        }

        if (isVisible) {
            element.classList.remove(this.fxxlHiddenClass);
        } else {
            element.classList.add(this.fxxlHiddenClass);
        }
    }

    private getProductDetailBranchTimesFunction(): ProductDetailGetBranchTimesFunction | null {
        const windowWithBranchTimes = window as Window & {
            fxxlGetBranchTimes?: ProductDetailGetBranchTimesFunction;
        };

        if (typeof windowWithBranchTimes.fxxlGetBranchTimes === 'function') {
            return windowWithBranchTimes.fxxlGetBranchTimes;
        }

        return null;
    }

    private clearProductDetailBranchInfoModalStatus(statusElement: HTMLElement | null): void {
        if (!statusElement) {
            return;
        }

        statusElement.textContent = '';
        statusElement.classList.remove(this.branchInfoModalStatusOpenClass);
        statusElement.classList.remove(this.branchInfoModalStatusCloseClass);
        statusElement.classList.add(this.fxxlHiddenClass);
    }

    private invalidateProductDetailBranchInfoModalStatusRequest(): void {
        this.branchInfoModalStatusRequestId += 1;
    }

    private updateProductDetailBranchInfoModalStatus(modalElement: SideModalElement, branchId: number): void {
        const statusElement = modalElement.querySelector<HTMLElement>(`.${this.branchInfoModalStatusClass}`);
        this.invalidateProductDetailBranchInfoModalStatusRequest();
        this.clearProductDetailBranchInfoModalStatus(statusElement);

        const getBranchTimesFunction = this.getProductDetailBranchTimesFunction();
        if (!getBranchTimesFunction || !statusElement) {
            return;
        }

        const requestId = this.branchInfoModalStatusRequestId;
        getBranchTimesFunction([branchId], (timesData: ProductDetailBranchTimesByBranch) => {
            if (requestId !== this.branchInfoModalStatusRequestId) {
                return;
            }

            const branchTimes = timesData[String(branchId)];
            if (!branchTimes || typeof branchTimes.status !== 'string') {
                this.clearProductDetailBranchInfoModalStatus(statusElement);
                return;
            }

            const statusText = branchTimes.status.trim();
            if (statusText.length === 0) {
                this.clearProductDetailBranchInfoModalStatus(statusElement);
                return;
            }

            statusElement.textContent = statusText;
            statusElement.classList.remove(this.fxxlHiddenClass);

            if (branchTimes.is_open === 1) {
                statusElement.classList.add(this.branchInfoModalStatusOpenClass);
            } else {
                statusElement.classList.add(this.branchInfoModalStatusCloseClass);
            }
        });
    }

    private updateProductDetailBranchInfoLink(selectedBranchId: number | null): void {
        const searchLinkElements = document.querySelectorAll<HTMLAnchorElement>(this.pdsBranchAvailabilitySearchLinkSelector);
        if (this.productDetailBranchLinksReady !== true) {
            searchLinkElements.forEach((linkElement) => {
                linkElement.classList.add(this.fxxlHiddenClass);
            });

            const infoLinkElementsBeforeReady = document.querySelectorAll<HTMLAnchorElement>(this.pdsBranchInfoLinkSelector);
            infoLinkElementsBeforeReady.forEach((linkElement) => {
                linkElement.classList.add(this.fxxlHiddenClass);
            });

            return;
        }

        searchLinkElements.forEach((linkElement) => {
            if (selectedBranchId === null) {
                linkElement.classList.remove(this.fxxlHiddenClass);
            } else {
                linkElement.classList.add(this.fxxlHiddenClass);
            }
        });

        const infoLinkElements = document.querySelectorAll<HTMLAnchorElement>(this.pdsBranchInfoLinkSelector);
        infoLinkElements.forEach((linkElement) => {
            if (selectedBranchId === null) {
                linkElement.classList.add(this.fxxlHiddenClass);
            } else {
                linkElement.classList.remove(this.fxxlHiddenClass);
            }
        });
    }

    private renderProductDetailBranchInfoModalContent(
        availabilityInfo: ProductDetailPageBranchAvailabilityInfo | null = null
    ): void {
        let selectedBranchId = this.getSelectedBranchIdForProductDetail();
        let mainProductId = this.getProductDetailMainProductIdFromAvailabilityContainer();

        if (availabilityInfo) {
            selectedBranchId = availabilityInfo.selectedBranchId;
            mainProductId = availabilityInfo.mainProductId;
        }

        this.updateProductDetailBranchInfoLink(selectedBranchId);

        const modalElement = this.getBranchInfoModalElement();
        if (!modalElement) {
            return;
        }

        const modalData = this.getProductDetailBranchInfoModalData(mainProductId, selectedBranchId);

        const emptyElement = modalElement.querySelector<HTMLElement>(`.${this.branchInfoModalEmptyClass}`);
        const summaryElement = modalElement.querySelector<HTMLElement>(`.${this.branchInfoModalSummaryClass}`);
        const detailsElement = modalElement.querySelector<HTMLElement>(`.${this.branchInfoModalDetailsClass}`);
        const imageElement = modalElement.querySelector<HTMLImageElement>(`.${this.branchInfoModalImageClass}`);
        const cityElement = modalElement.querySelector<HTMLElement>(`.${this.branchInfoModalCityClass}`);
        const addressNameElement = modalElement.querySelector<HTMLElement>(`.${this.branchInfoModalNameClass}`);
        const openingRowElement = modalElement.querySelector<HTMLElement>(`.${this.branchInfoModalOpeningRowClass}`);
        const openingElement = modalElement.querySelector<HTMLElement>(`.${this.branchInfoModalOpeningClass}`);
        const openingStatusElement = modalElement.querySelector<HTMLElement>(`.${this.branchInfoModalStatusClass}`);
        const addressRowElement = modalElement.querySelector<HTMLElement>(`.${this.branchInfoModalAddressRowClass}`);
        const addressElement = modalElement.querySelector<HTMLElement>(`.${this.branchInfoModalAddressClass}`);
        const phoneRowElement = modalElement.querySelector<HTMLElement>(`.${this.branchInfoModalPhoneRowClass}`);
        const phoneLinkElement = modalElement.querySelector<HTMLAnchorElement>(`.${this.branchInfoModalPhoneLinkClass}`);
        const emailRowElement = modalElement.querySelector<HTMLElement>(`.${this.branchInfoModalEmailRowClass}`);
        const emailLinkElement = modalElement.querySelector<HTMLAnchorElement>(`.${this.branchInfoModalEmailLinkClass}`);
        const pageLinkElement = modalElement.querySelector<HTMLAnchorElement>(`.${this.branchInfoModalPageLinkClass}`);
        const matrixLinkElement = modalElement.querySelector<HTMLElement>(this.pdsBranchInfoMatrixLinkSelector);
        const hasMatrixModal = document.getElementById(this.pdsBranchAvailabilityMatrixModalId) !== null;
        const hasSelectedLevel2 = this.hasProductDetailSelectedLevel2();

        if (!modalData) {
            this.setElementVisibility(emptyElement, true);
            this.setElementVisibility(summaryElement, false);
            this.setElementVisibility(detailsElement, false);
            this.setElementVisibility(openingRowElement, false);
            this.setElementVisibility(addressRowElement, false);
            this.setElementVisibility(phoneRowElement, false);
            this.setElementVisibility(emailRowElement, false);
            this.setElementVisibility(imageElement, false);
            this.setElementVisibility(pageLinkElement, false);
            this.setElementVisibility(
                matrixLinkElement,
                hasMatrixModal && (FxxlCore.isLargeViewport() === true || hasSelectedLevel2 === true)
            );

            if (cityElement) {
                cityElement.textContent = '';
            }
            if (addressNameElement) {
                addressNameElement.textContent = '';
            }
            if (openingElement) {
                openingElement.textContent = '';
            }
            if (addressElement) {
                addressElement.textContent = '';
            }

            if (phoneLinkElement) {
                phoneLinkElement.removeAttribute('href');
                phoneLinkElement.textContent = '';
            }
            if (emailLinkElement) {
                emailLinkElement.removeAttribute('href');
                emailLinkElement.textContent = '';
            }
            if (pageLinkElement) {
                pageLinkElement.removeAttribute('href');
            }
            this.invalidateProductDetailBranchInfoModalStatusRequest();
            this.clearProductDetailBranchInfoModalStatus(openingStatusElement);
            return;
        }

        this.setElementVisibility(emptyElement, false);
        this.setElementVisibility(summaryElement, true);
        this.setElementVisibility(detailsElement, true);

        if (cityElement) {
            cityElement.textContent = modalData.city;
        }
        if (addressNameElement) {
            addressNameElement.textContent = modalData.addressName;
            if (modalData.addressName.length > 0) {
                addressNameElement.classList.remove(this.fxxlHiddenClass);
            } else {
                addressNameElement.classList.add(this.fxxlHiddenClass);
            }
        }

        const openingTimes = this.getProductDetailBranchInfoModalOpeningTimes(modalData);
        if (openingElement) {
            this.setElementMultilineText(openingElement, openingTimes);
        }
        const hasOpeningTimes = openingTimes.length > 0;
        this.setElementVisibility(openingRowElement, hasOpeningTimes);
        if (hasOpeningTimes) {
            this.updateProductDetailBranchInfoModalStatus(modalElement, modalData.branchId);
        } else {
            this.invalidateProductDetailBranchInfoModalStatusRequest();
            this.clearProductDetailBranchInfoModalStatus(openingStatusElement);
        }

        const addressText = this.getProductDetailBranchInfoModalAddress(modalData);
        if (addressElement) {
            this.setElementMultilineText(addressElement, addressText);
        }
        this.setElementVisibility(addressRowElement, addressText.length > 0);

        if (phoneLinkElement) {
            if (modalData.phone.length > 0) {
                // Deutsche Schreibweisen wie "49 (0) 176 85 2626 06" für tel: normalisieren.
                const phoneHrefRaw = modalData.phone.replace(/\(\s*0\s*\)/g, '');
                const phoneHref = phoneHrefRaw.replace(/[^\d+]/g, '');
                phoneLinkElement.setAttribute('href', `tel:${phoneHref}`);
                phoneLinkElement.textContent = modalData.phone;
                this.setElementVisibility(phoneRowElement, true);
            } else {
                phoneLinkElement.removeAttribute('href');
                phoneLinkElement.textContent = '';
                this.setElementVisibility(phoneRowElement, false);
            }
        } else {
            this.setElementVisibility(phoneRowElement, false);
        }

        if (emailLinkElement) {
            if (modalData.email.length > 0) {
                emailLinkElement.setAttribute('href', `mailto:${modalData.email}`);
                emailLinkElement.textContent = modalData.email;
                this.setElementVisibility(emailRowElement, true);
            } else {
                emailLinkElement.removeAttribute('href');
                emailLinkElement.textContent = '';
                this.setElementVisibility(emailRowElement, false);
            }
        } else {
            this.setElementVisibility(emailRowElement, false);
        }

        if (pageLinkElement) {
            if (modalData.branchUrl.length > 0) {
                pageLinkElement.setAttribute('href', modalData.branchUrl);
                this.setElementVisibility(pageLinkElement, true);
            } else {
                pageLinkElement.removeAttribute('href');
                this.setElementVisibility(pageLinkElement, false);
            }
        }
        this.setElementVisibility(
            matrixLinkElement,
            hasMatrixModal && (FxxlCore.isLargeViewport() === true || hasSelectedLevel2 === true)
        );

        if (imageElement) {
            if (modalData.image.length > 0) {
                let imageAlt = modalData.city;
                if (modalData.addressName.length > 0 && modalData.city.length > 0) {
                    imageAlt = `${modalData.city} ${modalData.addressName}`;
                } else if (modalData.addressName.length > 0) {
                    imageAlt = modalData.addressName;
                }

                imageElement.setAttribute('src', modalData.image);
                imageElement.setAttribute('alt', imageAlt);
                this.setElementVisibility(imageElement, true);
            } else {
                imageElement.removeAttribute('src');
                imageElement.setAttribute('alt', '');
                this.setElementVisibility(imageElement, false);
            }
        }
    }

    private handleProductDetailBranchInfoModalKeydown(event: KeyboardEvent): void {
        if (event.key !== 'Escape') {
            return;
        }

        const modalElement = this.getBranchInfoModalElement();
        if (!modalElement || !modalElement.classList.contains(this.sideModalActiveClass)) {
            return;
        }

        if (modalElement.fxxlSideModal?.hideSideModal) {
            modalElement.fxxlSideModal.hideSideModal();
            event.preventDefault();
        }
    }

    private handleProductDetailBranchInfoModalOpen(modalElement: SideModalElement): void {
        const activeElement = document.activeElement;
        if (activeElement instanceof HTMLElement) {
            this.branchInfoModalLastFocusedElement = activeElement;
        } else {
            this.branchInfoModalLastFocusedElement = null;
        }

        this.renderProductDetailBranchInfoModalContent();

        const closeButtonElement = modalElement.querySelector<HTMLElement>(`.${this.sideModalCloseButtonClass}`);
        if (closeButtonElement) {
            closeButtonElement.focus();
        } else {
            const modalContainerElement = modalElement.querySelector<HTMLElement>(`.${this.branchInfoModalClass}`);
            if (modalContainerElement) {
                modalContainerElement.focus();
            }
        }

        if (this.branchInfoModalKeydownListener === null) {
            this.branchInfoModalKeydownListener = this.handleProductDetailBranchInfoModalKeydown.bind(this);
        }
        document.addEventListener('keydown', this.branchInfoModalKeydownListener);
    }

    private handleProductDetailBranchInfoModalClose(): void {
        if (this.branchInfoModalKeydownListener !== null) {
            document.removeEventListener('keydown', this.branchInfoModalKeydownListener);
        }

        if (this.branchInfoModalLastFocusedElement) {
            this.branchInfoModalLastFocusedElement.focus();
            this.branchInfoModalLastFocusedElement = null;
        }
    }

    private openProductDetailBranchAvailabilityModal(modalId: string): boolean {
        const modalElement = document.getElementById(modalId);
        if (!modalElement) {
            return false;
        }

        const windowWithMaterialize = window as Window & {
            M?: {
                Modal?: {
                    getInstance?: (element: Element) => { open?: () => void } | null;
                };
            };
        };

        if (windowWithMaterialize.M && windowWithMaterialize.M.Modal && windowWithMaterialize.M.Modal.getInstance) {
            const modalInstance = windowWithMaterialize.M.Modal.getInstance(modalElement);
            if (modalInstance && modalInstance.open) {
                modalInstance.open();
                this.ensureBranchMatrixLayout(modalId);
                return true;
            }
        }

        const triggerSelectors = [
            `.${this.articleDetailBranchButtonClass}[data-target="${modalId}"]`,
            `.${this.elementArtikelBranchButtonClass}[data-target="${modalId}"]`
        ];

        for (let index = 0; index < triggerSelectors.length; index += 1) {
            const triggerElement = document.querySelector<HTMLElement>(triggerSelectors[index]);
            if (!triggerElement) {
                continue;
            }

            triggerElement.click();
            this.ensureBranchMatrixLayout(modalId);
            return true;
        }

        return false;
    }

    private ensureBranchMatrixLayout(modalId: string): void {
        if (!modalId || modalId.indexOf(this.pdsBranchAvailabilityMatrixModalId) !== 0) {
            return;
        }

        const windowWithMatrix = window as Window & {
            setMatrixVariantSizes?: (containerElement: HTMLElement | Document, showSizeSelectorActive: boolean) => void;
        };

        if (typeof windowWithMatrix.setMatrixVariantSizes === 'function') {
            windowWithMatrix.setMatrixVariantSizes(document, false);
        } else {
            new FxxlError('setMatrixVariantSizes function is not available on window object');
        }
    }

    private setupBranchMatrixTabListener(): void {
        const matrixTabLinks = document.querySelectorAll<HTMLAnchorElement>(
            `.${this.pdsBranchAvailabilityTabsClass} a.fxxl-branch-availability-tab[href^="#fxxl_branch_availability_matrix"]`
        );
        matrixTabLinks.forEach((link) => {
            if (link.dataset.fxxlBranchMatrixTabBound === '1') {
                return;
            }

            link.addEventListener('click', () => {
                this.ensureBranchMatrixLayout(this.pdsBranchAvailabilityMatrixModalId);
            });

            link.dataset.fxxlBranchMatrixTabBound = '1';
        });
    }


    private selectProductDetailBranchAvailabilityMatrixTab(): void {
        const tabIndex =  +!FxxlCore.isLargeViewport() || 2;
        window.setTimeout(() => {
            const matrixTabSelector =
                `#${this.pdsBranchAvailabilityMatrixModalId} .${this.pdsBranchAvailabilityTabsClass} li:nth-of-type(${tabIndex}) > a`;
            const matrixTabElement = document.querySelector<HTMLElement>(matrixTabSelector);
            if (matrixTabElement) {
                matrixTabElement.click();
            }
        }, 100);
    }

    private setupProductDetailBranchInfoModalListeners(): void {
        if (this.branchInfoModalListenersInitialized) {
            return;
        }

        const sideModalElement = this.getBranchInfoModalElement();
        if (!sideModalElement || !sideModalElement.fxxlSideModal) {
            return;
        }

        const changeBranchButtons = sideModalElement.querySelectorAll<HTMLAnchorElement>('a[href="#search-branch-side-modal"]');
        changeBranchButtons.forEach((button) => {
            if (button.dataset.fxxlBranchInfoModalChangeBranchBound === '1') {
                return;
            }

            button.addEventListener('click', (event: Event) => {
                if (sideModalElement.fxxlSideModal?.hideSideModal) {
                    sideModalElement.fxxlSideModal.hideSideModal();
                }

                const searchBranchModalElement = document.getElementById(this.pdsBranchAvailabilityModalId) as SideModalElement | null;
                if (searchBranchModalElement?.fxxlSideModal?.openSideModal) {
                    searchBranchModalElement.fxxlSideModal.openSideModal();
                    event.preventDefault();
                }
            });

            button.dataset.fxxlBranchInfoModalChangeBranchBound = '1';
        });

        const matrixButtons = sideModalElement.querySelectorAll<HTMLAnchorElement>(this.pdsBranchInfoMatrixLinkSelector);
        matrixButtons.forEach((button) => {
            if (button.dataset.fxxlBranchInfoModalMatrixBound === '1') {
                return;
            }

            button.addEventListener('click', (event: Event) => {
                if (sideModalElement.fxxlSideModal?.hideSideModal) {
                    sideModalElement.fxxlSideModal.hideSideModal();
                }

                const modalWasOpened = this.openProductDetailBranchAvailabilityModal(this.pdsBranchAvailabilityMatrixModalId);
                if (modalWasOpened) {
                    this.selectProductDetailBranchAvailabilityMatrixTab();
                    event.preventDefault();
                }
            });

            button.dataset.fxxlBranchInfoModalMatrixBound = '1';
        });

        const oldOnSideModalOpen = sideModalElement.fxxlSideModal.onSideModalOpen;
        const oldOnSideModalClose = sideModalElement.fxxlSideModal.onSideModalClose;

        sideModalElement.fxxlSideModal.onSideModalOpen = () => {
            if (oldOnSideModalOpen) {
                oldOnSideModalOpen();
            }
            this.handleProductDetailBranchInfoModalOpen(sideModalElement);
        };
        sideModalElement.fxxlSideModal.onSideModalClose = () => {
            if (oldOnSideModalClose) {
                oldOnSideModalClose();
            }
            this.handleProductDetailBranchInfoModalClose();
        };

        this.branchInfoModalListenersInitialized = true;
    }

    private ensureProductDetailBranchInfoModalListeners(retryAttempts = 40): void {
        this.setupProductDetailBranchInfoModalListeners();
        if (this.branchInfoModalListenersInitialized || retryAttempts <= 0) {
            return;
        }

        window.setTimeout(() => {
            this.ensureProductDetailBranchInfoModalListeners(retryAttempts - 1);
        }, 50);
    }

    public setupProductDetailBranchInfoModalLink(): void {
        const links = document.querySelectorAll<HTMLAnchorElement>(this.pdsBranchInfoLinkSelector);
        links.forEach((link) => {
            if (link.dataset.fxxlBranchInfoModalBound === '1') {
                return;
            }

            link.addEventListener('click', (event: Event) => {
                this.renderProductDetailBranchInfoModalContent();
                this.ensureProductDetailBranchInfoModalListeners();

                const sideModalElement = this.getBranchInfoModalElement();
                if (sideModalElement?.fxxlSideModal?.openSideModal) {
                    sideModalElement.fxxlSideModal.openSideModal();
                    event.preventDefault();
                }
            });

            link.dataset.fxxlBranchInfoModalBound = '1';
        });

        this.ensureProductDetailBranchInfoModalListeners();
    }

    private getProductDetailMainProductId(availabilityByArticle: ProductDetailAvailabilityByArticle): string | null {
        const mainProductIdFromAvailabilityContainer = this.getProductDetailMainProductIdFromAvailabilityContainer();
        if (mainProductIdFromAvailabilityContainer !== null && availabilityByArticle[mainProductIdFromAvailabilityContainer]) {
            return mainProductIdFromAvailabilityContainer;
        }

        const branchInventoryElement = document.querySelector<HTMLElement>(`.${this.branchInventoryClass}[data-main-id]`);
        const mainProductIdFromDom = branchInventoryElement?.dataset?.mainId?.trim() || '';
        if (mainProductIdFromDom.length > 0 && availabilityByArticle[mainProductIdFromDom]) {
            return mainProductIdFromDom;
        }

        const articleIds = Object.keys(availabilityByArticle);
        if (articleIds.length > 0) {
            return articleIds[0];
        }

        return null;
    }

    private getProductDetailAvailabilityRows(
        availabilityByVariant: ProductDetailAvailabilityByVariant
    ): ProductDetailAvailabilityRow[] {
        const rows: ProductDetailAvailabilityRow[] = [];

        Object.values(availabilityByVariant).forEach((availabilityByBranch) => {
            Object.values(availabilityByBranch).forEach((entry) => {
                const normalizedVariantId = this.normalizeProductId(entry.variantId);
                const normalizedBranchId = this.normalizeBranchId(entry.branchId);
                const numericStock = Number(entry.stock);
                let normalizedStock = 0;
                if (Number.isFinite(numericStock)) {
                    normalizedStock = numericStock;
                }

                if (normalizedVariantId === null || normalizedBranchId === null) {
                    return;
                }

                const isOnlineAvailable = entry.onlineAvailable === true && normalizedStock > 0;
                const status = this.normalizeAvailabilityStatus(entry.status, normalizedStock);

                rows.push({
                    variantId: normalizedVariantId,
                    branchId: normalizedBranchId,
                    stock: normalizedStock,
                    onlineAvailable: isOnlineAvailable,
                    status
                });
            });
        });

        return rows;
    }

    private buildProductDetailPageBranchAvailabilityInfo(
        variantId: number | string | null = null
    ): ProductDetailPageBranchAvailabilityInfo | null {
        const availabilityByArticle =
            window?.fxxlArtikelBranchInventoryVariantAvailability as ProductDetailAvailabilityByArticle | undefined;

        if (!availabilityByArticle) {
            return null;
        }

        const mainProductId = this.getProductDetailMainProductId(availabilityByArticle);
        if (mainProductId === null) {
            return null;
        }

        const availabilityByVariant = availabilityByArticle[mainProductId];
        if (!availabilityByVariant) {
            return null;
        }

        const rows = this.getProductDetailAvailabilityRows(availabilityByVariant);
        const normalizedVariantId = this.normalizeProductId(variantId);
        const selectedBranchId = this.getSelectedBranchIdForProductDetail();
        const selectedLevel1Index = this.getProductDetailSelectedLevel1Index();
        const hasSelectedLevel2 = this.hasProductDetailSelectedLevel2();
        const effectiveVariantId = hasSelectedLevel2 ? normalizedVariantId : null;

        let rowsForSelection = rows;
        if (effectiveVariantId === null && hasSelectedLevel2 !== true && selectedLevel1Index !== null) {
            const level1VariantIds = this.getProductDetailVariantIdsByLevel1Index(selectedLevel1Index);
            if (level1VariantIds.size > 0) {
                rowsForSelection = rows.filter((row) => level1VariantIds.has(row.variantId));
            }
        }

        let scenario: ProductDetailAvailabilityScenario;
        let matchingAvailableRows: ProductDetailAvailabilityRow[];
        let matchingDisplayRows: ProductDetailAvailabilityRow[];

        const isDisplayRow = (row: ProductDetailAvailabilityRow): boolean => {
            return row.status === 'available' || row.status === 'inquiry';
        };

        if (effectiveVariantId === null && selectedBranchId === null) {
            // Szenario 1: Kein Variant-Event, keine Filiale ausgewählt.
            scenario = 'initial_without_variant_without_selected_branch';
            matchingAvailableRows = rowsForSelection.filter((row) => row.status === 'available');
            matchingDisplayRows = rowsForSelection.filter((row) => isDisplayRow(row));
        } else if (effectiveVariantId === null && selectedBranchId !== null) {
            // Szenario 2: Kein Variant-Event, Filiale ausgewählt.
            scenario = 'initial_without_variant_with_selected_branch';
            matchingAvailableRows = rowsForSelection.filter((row) => {
                return row.status === 'available' && row.branchId === selectedBranchId;
            });
            matchingDisplayRows = rowsForSelection.filter((row) => {
                return isDisplayRow(row) && row.branchId === selectedBranchId;
            });
        } else if (effectiveVariantId !== null && selectedBranchId === null) {
            // Szenario 3: Variante gewählt, keine Filiale ausgewählt.
            scenario = 'variant_selected_without_selected_branch';
            matchingAvailableRows = rowsForSelection.filter((row) => {
                return row.status === 'available' && row.variantId === effectiveVariantId;
            });
            matchingDisplayRows = rowsForSelection.filter((row) => {
                return isDisplayRow(row) && row.variantId === effectiveVariantId;
            });
        } else {
            // Szenario 4: Variante gewählt und Filiale ausgewählt.
            scenario = 'variant_selected_with_selected_branch';
            matchingAvailableRows = rowsForSelection.filter((row) => {
                return row.status === 'available' && row.variantId === effectiveVariantId && row.branchId === selectedBranchId;
            });
            matchingDisplayRows = rowsForSelection.filter((row) => {
                return isDisplayRow(row) && row.variantId === effectiveVariantId && row.branchId === selectedBranchId;
            });
        }

        const matchingVariantIds = Array.from(new Set(matchingDisplayRows.map((row) => row.variantId)));
        const matchingBranchIds = Array.from(new Set(matchingDisplayRows.map((row) => row.branchId)));
        const availableStockCount = matchingAvailableRows.reduce((sum, row) => sum + row.stock, 0);
        const hasOnlineStock = matchingAvailableRows.length > 0;
        const hasDisplayStock = matchingDisplayRows.length > 0;
        const hasInquiryInSelectedBranch = selectedBranchId !== null
            && rowsForSelection.some((row) => {
                if (row.status !== 'inquiry' || row.branchId !== selectedBranchId) {
                    return false;
                }

                if (effectiveVariantId !== null) {
                    return row.variantId === effectiveVariantId;
                }

                return true;
            });
        let noAvailabilityInfoType: ProductDetailNoAvailabilityInfoType | null = null;

        if (hasDisplayStock !== true) {
            if (selectedBranchId === null) {
                noAvailabilityInfoType = 'without_selected_branch';
            } else {
                noAvailabilityInfoType = 'with_selected_branch';
            }
        }

        return {
            mainProductId,
            scenario,
            variantId: effectiveVariantId,
            selectedBranchId,
            hasOnlineStock,
            hasDisplayStock,
            hasInquiryInSelectedBranch,
            availableVariantsCount: matchingVariantIds.length,
            availableBranchesCount: matchingBranchIds.length,
            availableStockCount,
            matchingVariantIds,
            matchingBranchIds,
            noAvailabilityInfo: {
                show: !hasDisplayStock,
                // Szenario 5: Kein Filialbestand -> zwei unterschiedliche Infos abhängig von Filialauswahl.
                type: noAvailabilityInfoType
            }
        };
    }

    private logProductDetailBranchAvailabilityInfo(
        availabilityInfo: ProductDetailPageBranchAvailabilityInfo | null
    ): void {
        if (availabilityInfo) {
            // Nur für Debugging-Zwecke
            // console.log('Produktdetailseite: Artikelverfügbarkeitsinformationen für Filialen', availabilityInfo);
        }
    }

    private handleProductDetailVariantSelection(
        variantId: number | string | null
    ): ProductDetailPageBranchAvailabilityInfo | null {
        const variantAvailabilityInfo = this.buildProductDetailPageBranchAvailabilityInfo(variantId);
        this.logProductDetailBranchAvailabilityInfo(variantAvailabilityInfo);
        this.renderProductDetailBranchAvailabilitySubInfo(variantAvailabilityInfo);
        return variantAvailabilityInfo;
    }

    private queueProductDetailVariantSelection(
        variantId: number | string | null,
        priority: number
    ): void {
        let normalizedVariantId: string | null = null;
        if (variantId !== null && variantId !== undefined) {
            normalizedVariantId = this.normalizeProductId(variantId);
            if (normalizedVariantId === null) {
                return;
            }
        }

        if (
            this.productDetailVariantSelectionPendingRequested !== true
            || priority >= this.productDetailVariantSelectionPendingPriority
        ) {
            this.productDetailVariantSelectionPendingVariantId = normalizedVariantId;
            this.productDetailVariantSelectionPendingPriority = priority;
            this.productDetailVariantSelectionPendingRequested = true;
        }

        if (this.productDetailVariantSelectionTimerId !== null) {
            window.clearTimeout(this.productDetailVariantSelectionTimerId);
        }

        this.productDetailVariantSelectionTimerId = window.setTimeout(() => {
            this.productDetailVariantSelectionTimerId = null;
            const pendingVariantId = this.productDetailVariantSelectionPendingVariantId;
            this.productDetailVariantSelectionPendingVariantId = null;
            this.productDetailVariantSelectionPendingPriority = 0;
            const pendingRequestWasSet = this.productDetailVariantSelectionPendingRequested;
            this.productDetailVariantSelectionPendingRequested = false;

            if (pendingRequestWasSet) {
                this.handleProductDetailVariantSelection(pendingVariantId);
            }
        }, 0);
    }

    private setElementMultilineText(element: HTMLElement | null, value: string): void {
        if (!element) {
            return;
        }

        if (value.length === 0) {
            element.innerHTML = '';
            return;
        }

        element.innerHTML = value;
    }

    private setProductDetailBranchSubInfoTextNumber(
        textElement: HTMLElement,
        number: number
    ): void {
        const oneTemplate = textElement.dataset.one || '';
        const otherTemplate = textElement.dataset.other || '';

        if (oneTemplate || otherTemplate) {
            let pluralTemplateText;
            if (number === 1) {
                pluralTemplateText = oneTemplate || otherTemplate || '';
            } else {
                pluralTemplateText = otherTemplate || oneTemplate || '';
            }

            textElement.textContent = pluralTemplateText.replace(/###number###/g, String(number));
            return;
        }

        const templateText = textElement.dataset.fxxlTemplateText || textElement.textContent || '';
        if (!textElement.dataset.fxxlTemplateText) {
            textElement.dataset.fxxlTemplateText = templateText;
        }
        textElement.textContent = templateText.replace(/###number###/g, String(number));
    }

    private renderProductDetailBranchAvailabilitySubInfo(
        availabilityInfo: ProductDetailPageBranchAvailabilityInfo | null
    ): void {
        let branchAvailabilityContainer = this.getProductDetailBranchAvailabilityContainer();
        if (availabilityInfo && availabilityInfo.variantId !== null) {
            const branchAvailabilityContainerByVariantId = document.querySelector<HTMLElement>(
                `.${this.pdsBranchAvailabilityContainerClass}[data-variant-id="${availabilityInfo.variantId}"]`
            );
            if (branchAvailabilityContainerByVariantId) {
                branchAvailabilityContainer = branchAvailabilityContainerByVariantId;
            }
        }

        if (!branchAvailabilityContainer) {
            this.renderProductDetailBranchInfoModalContent(availabilityInfo);
            return;
        }

        this.productDetailBranchLinksReady = true;

        const spinnerElement = branchAvailabilityContainer.querySelector<HTMLElement>(`.${this.pdsBranchAvailabilitySpinnerClass}`);
        if (spinnerElement) {
            spinnerElement.classList.add(this.fxxlHiddenClass);
        }
        const branchIconElement = branchAvailabilityContainer.querySelector<HTMLElement>(`.${this.pdsBranchAvailabilityIconClass}`);

        const statusElement = branchAvailabilityContainer.querySelector<HTMLElement>(`.${this.pdsBranchAvailabilityStatusClass}`);
        if (!statusElement) {
            return;
        }
        const infoElement = branchAvailabilityContainer.querySelector<HTMLElement>(`.${this.pdsBranchAvailabilityInfoClass}`);
        const selectedBranchElement = branchAvailabilityContainer.querySelector<HTMLElement>(`.${this.pdsBranchAvailabilitySelectedBranchClass}`);

        const textElements: Record<ProductDetailBranchSubInfoTextKey, HTMLElement | null> = {
            branchAvailable: statusElement.querySelector<HTMLElement>(`.${this.pdsBranchAvailabilityTextBranchAvailableClass}`),
            branchUnavailable: statusElement.querySelector<HTMLElement>(`.${this.pdsBranchAvailabilityTextBranchUnavailableClass}`),
            myBranchAvailable: statusElement.querySelector<HTMLElement>(`.${this.pdsBranchAvailabilityTextMyBranchAvailableClass}`),
            myBranchVariantAvailable: statusElement.querySelector<HTMLElement>(`.${this.pdsBranchAvailabilityTextMyBranchVariantAvailableClass}`),
            myBranchInquiry: statusElement.querySelector<HTMLElement>(`.${this.pdsBranchAvailabilityTextMyBranchInquiryClass}`),
            myBranchUnavailable: statusElement.querySelector<HTMLElement>(`.${this.pdsBranchAvailabilityTextMyBranchUnavailableClass}`)
        };

        Object.values(textElements).forEach((textElement) => {
            if (textElement) {
                textElement.classList.add(this.fxxlHiddenClass);
            }
        });

        if (!availabilityInfo) {
            let fallbackTextElement = textElements.branchUnavailable;
            const selectedBranchId = this.getSelectedBranchIdForProductDetail();
            if (selectedBranchId !== null) {
                fallbackTextElement = textElements.myBranchUnavailable;
            }

            if (branchIconElement) {
                branchIconElement.classList.remove(this.fxxlHiddenClass);
            }
            statusElement.classList.remove(this.fxxlHiddenClass);

            if (fallbackTextElement) {
                this.setSelectedBranchLabel(fallbackTextElement);
                fallbackTextElement.classList.remove(this.fxxlHiddenClass);
            }

            this.renderProductDetailBranchInfoModalContent(null);
            return;
        }

        let selectedTextKey: ProductDetailBranchSubInfoTextKey;
        let numberToRender: number | null = null;

        const hasVariantAndBranch = availabilityInfo.variantId !== null && availabilityInfo.selectedBranchId !== null;
        if (hasVariantAndBranch) {
            if (availabilityInfo.hasOnlineStock) {
                selectedTextKey = 'myBranchVariantAvailable';
                numberToRender = availabilityInfo.availableStockCount;
            } else if (availabilityInfo.hasInquiryInSelectedBranch) {
                selectedTextKey = 'myBranchInquiry';
            } else {
                selectedTextKey = 'myBranchUnavailable';
            }
        } else if (availabilityInfo.hasDisplayStock) {
            if (
                availabilityInfo.scenario === 'initial_without_variant_without_selected_branch'
                || availabilityInfo.scenario === 'variant_selected_without_selected_branch'
            ) {
                selectedTextKey = 'branchAvailable';
                numberToRender = availabilityInfo.availableBranchesCount;
            } else {
                selectedTextKey = 'myBranchAvailable';
                numberToRender = availabilityInfo.availableVariantsCount;
            }
        } else if (availabilityInfo.noAvailabilityInfo.type === 'with_selected_branch') {
            selectedTextKey = 'myBranchUnavailable';
        } else {
            selectedTextKey = 'branchUnavailable';
        }

        const selectedTextElement = textElements[selectedTextKey];
        if (!selectedTextElement) {
            this.renderProductDetailBranchInfoModalContent(availabilityInfo);
            return;
        }

        if (selectedTextKey === 'myBranchVariantAvailable' && numberToRender !== null) {
            let limit = 10;
            const limitFromGlobals = this.getBranchAvailableProductLimitFromGlobals();
            if (limitFromGlobals !== null) {
                limit = limitFromGlobals;
            }

            if (numberToRender > limit) {
                const aboveLimitText = this.normalizeTextValue(selectedTextElement.dataset.aboveLimitText);
                if (aboveLimitText.length > 0) {
                    selectedTextElement.textContent = aboveLimitText;
                    numberToRender = null;
                }
            }
        }

        if (numberToRender !== null) {
            this.setProductDetailBranchSubInfoTextNumber(selectedTextElement, numberToRender);
        }
        if (selectedTextKey === 'myBranchInquiry' && availabilityInfo.variantId !== null) {
            const selectedTemplate = selectedTextElement.dataset.selected || selectedTextElement.textContent || '';
            selectedTextElement.textContent = selectedTemplate;
        }
        if (
            selectedTextKey === 'myBranchInquiry'
            || selectedTextKey === 'myBranchVariantAvailable'
        ) {
            selectedTextElement.dataset.fxxlBranchTemplate = selectedTextElement.textContent || '';
        }
        this.setSelectedBranchLabel(selectedTextElement);
        if (selectedTextKey === 'myBranchInquiry') {
            this.updateProductDetailBranchInquiryLink(selectedTextElement, availabilityInfo);
        }

        let showSelectedBranchInfo = false;
        if (selectedBranchElement) {
            selectedBranchElement.classList.add(this.fxxlHiddenClass);
            if (availabilityInfo.selectedBranchId !== null) {
                this.setSelectedBranchLabel(selectedBranchElement);
                selectedBranchElement.classList.remove(this.fxxlHiddenClass);
                showSelectedBranchInfo = true;
            }
        }

        if (infoElement) {
            if (showSelectedBranchInfo) {
                infoElement.classList.remove(this.fxxlHiddenClass);
            } else {
                infoElement.classList.add(this.fxxlHiddenClass);
            }
        }

        if (showSelectedBranchInfo) {
            branchAvailabilityContainer.classList.remove(this.pdsBranchAvailabilityContainerWithoutSelectedBranchClass);
        } else {
            branchAvailabilityContainer.classList.add(this.pdsBranchAvailabilityContainerWithoutSelectedBranchClass);
        }

        if (branchIconElement) {
            branchIconElement.classList.remove(this.fxxlHiddenClass);
        }
        statusElement.classList.remove(this.fxxlHiddenClass);
        selectedTextElement.classList.remove(this.fxxlHiddenClass);
        this.renderProductDetailBranchInfoModalContent(availabilityInfo);
    }

    private hasProductDetailBranchAvailabilityContext(): boolean {
        if (this.getProductDetailBranchAvailabilityContainer() !== null) {
            return true;
        }

        return window?.fxxlArtikelBranchInventoryVariantAvailability !== undefined;
    }

    private refreshProductDetailBranchAvailabilityInfo(): void {
        if (!this.hasProductDetailBranchAvailabilityContext()) {
            return;
        }

        const updatedAvailabilityInfo = this.buildProductDetailPageBranchAvailabilityInfo();
        this.logProductDetailBranchAvailabilityInfo(updatedAvailabilityInfo);
        this.renderProductDetailBranchAvailabilitySubInfo(updatedAvailabilityInfo);
    }

    private setupProductDetailBranchFilterChangedListener(): void {
        if (this.productDetailBranchFilterListenerInitialized) {
            return;
        }

        window.addEventListener(this.branchFilterChangedEventName, () => {
            this.refreshProductDetailBranchAvailabilityInfo();
        });

        const personalDataLoadedEventName = FxxlCore.getConfig()?.eventNames?.personalDataLoaded;
        if (personalDataLoadedEventName) {
            window.addEventListener(personalDataLoadedEventName, () => {
                this.refreshProductDetailBranchAvailabilityInfo();
            });
        }

        this.productDetailBranchFilterListenerInitialized = true;
    }

    private setupProductDetailBranchAvailabilityModalLink(): void {
        const links = document.querySelectorAll<HTMLAnchorElement>(this.pdsBranchAvailabilityLinkSelector);
        links.forEach((link) => {
            if (link.dataset.fxxlBranchModalFallbackBound === '1') {
                return;
            }

            link.addEventListener('click', (event: Event) => {
                const sideModalElement = document.getElementById(this.pdsBranchAvailabilityModalId) as
                    (HTMLElement & { fxxlSideModal?: { openSideModal?: () => void } }) | null;

                if (sideModalElement?.fxxlSideModal?.openSideModal) {
                    sideModalElement.fxxlSideModal.openSideModal();
                    event.preventDefault();
                }
            });

            link.dataset.fxxlBranchModalFallbackBound = '1';
        });
    }

    public productDetailPageBranchAvailabilityInfo(): ProductDetailPageBranchAvailabilityInfo | null {
        const pdsVariantSelectorElement = document.querySelector(`.${this.pdsVariantSelectorClass}`);
        if (pdsVariantSelectorElement && !this.productDetailVariantSelectorListenerInitialized) {
            const colorChangedEventPriority = 1;
            const level1ChangedEventPriority = 2;
            const variantSelectedEventPriority = 3;

            pdsVariantSelectorElement.addEventListener('fxxl-variant-selector_color-changed', () => {
                this.queueProductDetailVariantSelection(null, colorChangedEventPriority);
            });

            pdsVariantSelectorElement.addEventListener('fxxl-variant-selector_level-1-changed', () => {
                this.queueProductDetailVariantSelection(null, level1ChangedEventPriority);
            });

            pdsVariantSelectorElement.addEventListener('fxxl-variant-selector_variant-selected', (event: Event) => {
                const variantSelectedEvent = event as VariantSelectorSelectedEvent;
                this.queueProductDetailVariantSelection(
                    variantSelectedEvent.detail.pid,
                    variantSelectedEventPriority
                );
            });

            this.productDetailVariantSelectorListenerInitialized = true;
        }
        this.setupProductDetailBranchAvailabilityModalLink();
        this.setupProductDetailBranchFilterChangedListener();
        this.setupBranchMatrixTabListener();

        const initialAvailabilityInfo = this.buildProductDetailPageBranchAvailabilityInfo();
        this.logProductDetailBranchAvailabilityInfo(initialAvailabilityInfo);
        this.renderProductDetailBranchAvailabilitySubInfo(initialAvailabilityInfo);
        this.renderProductDetailBranchInfoModalContent(initialAvailabilityInfo);
        return initialAvailabilityInfo;
    }

    public updateArticleAvailabilityInfo(): void {
        const branchId: number | null = this.getSelectedBranchId();
        const items  = document.querySelectorAll<HTMLElement>(`.${this.articleAvailabilityInfoElementClass}`);

        items.forEach((element) => {
            const availableBranchs: string | undefined = element?.dataset?.availableonbranch;
            const availableBranchsList = this.parseAvailableBranchesList(availableBranchs);
            const availableMyBranchElement = element.querySelector<HTMLElement>(`.${this.articleAvailableMyBranchClass}`);
            const unavailableMyBranchElement = element.querySelector<HTMLElement>(`.${this.articleUnavilableMyBranchClass}`);
            const availableBranchElement = element.querySelector<HTMLElement>(`.${this.articleAvailableBranchClass}`);
            const unavailableBranchElement = element.querySelector<HTMLElement>(`.${this.articleUnavilableBranchClass}`);
            const hiddenLoaderElement = element.querySelector<HTMLElement>(`.${this.articleAvailableInfoLoaderClass}`);
            // if branchId is null, then no branch is selected
            if (branchId !== null && availableBranchsList?.includes(branchId)) {
                // Ausgewählte Filiale ist in der Liste der verfügbaren Filialen
                this.setSelectedBranchLabel(availableMyBranchElement);
                this.showCategoryPageAvailabilityInfo(availableMyBranchElement);
            } else if (branchId !== null) {
                // Ausgewählte Filiale ist nicht in der Liste der verfügbaren Filialen
                this.setSelectedBranchLabel(unavailableMyBranchElement);
                this.showCategoryPageAvailabilityInfo(unavailableMyBranchElement);
            } else {
                // Keine Filiale ausgewählt
                if (availableBranchsList.some((id) => id !== 0)) {
                    // Es gibt verfügbare Filialen
                    this.showCategoryPageAvailabilityInfo(availableBranchElement);
                } else {
                    // Es gibt keine verfügbaren Filialen
                    this.showCategoryPageAvailabilityInfo(unavailableBranchElement);
                }
            }
            // Loader ausblenden
            if (hiddenLoaderElement) {
                hiddenLoaderElement.classList.add(this.fxxlHiddenClass);
            }
        });
    }


}
